import React from 'react';
import logo from './../assets/logo.svg';

export default function() {
  return (
    <div
      style={{
        margin: '0',
        padding: '35px 50px 50px 50px',
        fontFamily: 'Rubik',
        fontSize: '16px',
        color: '#485858',
        lineHeight: '130%',
        letterSpacing: '0.015px',
        fontWeight: 400
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          maxWidth: '1260px',
          margin: 'auto'
        }}
      >
        <div style={{ flex: '1 1 600px' }}>
          <img src={logo} alt="" />
          <div
            style={{
              fontStyle: 'SemiBold',
              paddingTop: '118px',
              fontWeight: 600,
              fontSize: '36px',
              lineHeight: '100%',
              color: '#169493'
            }}
          >
            UPLATFORMA 1.0 - онлайн-платформа для оценки персонала
          </div>
          <div
            style={{
              paddingTop: '35px'
            }}
          >
            <span style={{ fontWeight: 700 }}>UPLATFORMA 1.0</span> - это
            онлайн-платформа для управления персоналом на основе данных, которая
            работает по модели SaaS. Платформа автоматизирует процессы
            онлайн-оценки и расчетов на основе моделей компетенций при поиске,
            найме, управлении эффективностью и карьерном продвижении сотрудников
            и кандидатов.
          </div>
          <div
            style={{
              paddingTop: '20px'
            }}
          >
            <span style={{ fontWeight: 700 }}>
              Основное преимущество системы
            </span>{' '}
            — отсутствие затрат на установку, обновление и поддержку
            оборудования и ПО. Доступ предоставляется через веб-браузер по
            защищенному протоколу, обеспечивающему безопасную передачу данных.
            Платформа обладает интуитивно понятным интерфейсом с терминологией
            для каждой предметной области.
          </div>
          <div
            style={{
              fontStyle: 'SemiBold',
              paddingTop: '60px',
              fontWeight: 600,
              fontSize: '36px',
              lineHeight: '100%',
              color: '#169493'
            }}
          >
            Основная функциональность
          </div>
          <div
            style={{
              paddingTop: '35px'
            }}
          >
            Платформа предназначена для измерения человеческого капитала и
            автоматизации процессов подбора, адаптации, развития и удержания
            персонала. В основе системы лежат технологии машинного обучения.
          </div>
          <div
            style={{
              paddingTop: '15px'
            }}
          >
            <span style={{ fontWeight: 700 }}>
              Ключевые функциональные возможности:
            </span>
          </div>
          <div
            style={{
              paddingTop: '15px'
            }}
          >
            - проведение тестов различной направленности: soft skills,
            когнитивные способности, Оценка 360, мотивация, профессиональные
            знания;
          </div>
          <div
            style={{
              paddingTop: '10px'
            }}
          >
            - комплексная оценка по параметрам: компетенции, ценности,
            потенциал, риски, мотивация, выгорание, интеллектуальные
            способности;
          </div>
          <div
            style={{
              paddingTop: '10px'
            }}
          >
            - проведение исследований мнений сотрудников: вовлеченность,
            удовлетворенность, приверженность;
          </div>
          <div
            style={{
              paddingTop: '10px'
            }}
          >
            - конструктор индивидуальных планов развития;
          </div>
          <div
            style={{
              paddingTop: '10px'
            }}
          >
            - единый личный кабинет с полной аналитикой и историей оценок;
          </div>
          <div
            style={{
              paddingTop: '10px'
            }}
          >
            - гибкая настройка уровней доступа и брендинг платформы;
          </div>
          <div
            style={{
              paddingTop: '10px'
            }}
          >
            - интеграции с HRM-системами и API-подключения;
          </div>
          <div
            style={{
              paddingTop: '10px'
            }}
          >
            - поддержка на всех этапах: от внедрения до сопровождения.
          </div>
          <div
            style={{
              paddingTop: '30px'
            }}
          >
            <span style={{ fontWeight: 700 }}>Целевые пользователи:</span>
          </div>
          <div
            style={{
              paddingTop: '15px'
            }}
          >
            - сотрудники HR-подразделений организаций;
          </div>
          <div
            style={{
              paddingTop: '10px'
            }}
          >
            - руководители;
          </div>
          <div
            style={{
              paddingTop: '10px'
            }}
          >
            - сотрудники.
          </div>
          <div
            style={{
              fontStyle: 'SemiBold',
              paddingTop: '60px',
              fontWeight: 600,
              fontSize: '36px',
              lineHeight: '100%',
              color: '#169493'
            }}
          >
            Продукты системы онлайн оценки персонала
          </div>
          <div
            style={{
              paddingTop: '35px'
            }}
          >
            <span style={{ fontWeight: 700 }}>
              Оценка потенциала успешного рабочего поведения
            </span>
            <br />
            Интегральная оценка потенциала сотрудника — комплексная оценка
            способностей, личностных компетенций, готовности к развитию, которая
            позволяет прогнозировать его успешное рабочее поведение для
            достижения высоких результатов в будущем, а также способность
            вносить значимый вклад в успех организации.
          </div>
          <div
            style={{
              paddingTop: '20px'
            }}
          >
            <span style={{ fontWeight: 700 }}>
              Вопросы для собеседования STAR
            </span>
            <br />
            Готовые вопросы рекрутеру для собеседования на основе научно
            обоснованной оценки прогноза рабочего поведения.
          </div>
          <div
            style={{
              paddingTop: '20px'
            }}
          >
            <span style={{ fontWeight: 700 }}>
              ИПР Рекомендации по развитию
            </span>
            <br />
            Индивидуальный план развития, созданный на основе реальных
            компетенций - персонализированный подход и реальнех данные для
            создания ИПР. Готовая библиотека развивающих действий на рабочем
            месте, рекомендуемой литературы и тем тренингов.
          </div>
          <div
            style={{
              paddingTop: '20px'
            }}
          >
            <span style={{ fontWeight: 700 }}>Топики для обратной связи</span>
            <br />
            Темы для развития сотрудников и пошаговая инструкция для беседы с
            руководителем — персонализированный подход для каждого сотрудника.
          </div>
          <div
            style={{
              paddingTop: '20px'
            }}
          >
            <span style={{ fontWeight: 700 }}>Командные роли</span>
            <br />
            Ключ к успешному сотрудничеству и высокому результату. Знание
            сильных сторон и сочетания ролей сотрудников ведет к лучшему
            сотрудничеству и результату.
          </div>
          <div
            style={{
              paddingTop: '20px'
            }}
          >
            <span style={{ fontWeight: 700 }}>Стиль принятия решений</span>
            <br />
            Персонализированная характеристика стиля принятия решений, важная
            информация при найме и для руководителя сотрудника.
          </div>
          <div
            style={{
              fontStyle: 'SemiBold',
              paddingTop: '60px',
              fontWeight: 600,
              fontSize: '36px',
              lineHeight: '100%',
              color: '#169493'
            }}
          >
            Тарифы и стоимость
          </div>
          <div
            style={{
              paddingTop: '35px'
            }}
          >
            Стоимость использования системы вы можете узнать по почте{' '}
            <a
              style={{ textDecoration: 'none', color: '#485858' }}
              href="mailto:info@uplatforma.ru"
            >
              info@uplatforma.ru
            </a>{' '}
            или по телефону{' '}
            <a
              style={{ textDecoration: 'none', color: '#485858' }}
              href="tel:+74952563733"
            >
              +7 495 256 37 33
            </a>
          </div>
          <div
            style={{
              fontStyle: 'SemiBold',
              paddingTop: '60px',
              fontWeight: 600,
              fontSize: '36px',
              lineHeight: '100%',
              color: '#169493'
            }}
          >
            Документация
          </div>
          <table
            style={{
              marginTop: '35px',
              borderCollapse: 'collapse',
              border: '2px solid rgb(140 140 140)',
              width: '100%',
              fontSize: '14px'
            }}
          >
            <tbody>
              <tr style={{ height: '65px' }}>
                <td
                  style={{
                    border: '1px solid rgb(160 160 160)',
                    padding: '7px 0 0 10px',
                    verticalAlign: 'baseline'
                  }}
                >
                  Документация, содержащая описание процессов, обеспечивающих
                  поддержание жизненного цикла, в том числе устранение
                  неисправностей и совершенствование, а также информацию о
                  персонале, необходимом для обеспечения такой поддержки
                </td>
                <td
                  style={{
                    border: '1px solid rgb(160 160 160)',
                    padding: '7px 0 0 10px',
                    verticalAlign: 'baseline'
                  }}
                >
                  <a
                    style={{ textDecoration: 'none', color: '#3054e8' }}
                    target="_blank"
                    href="https://main.uplatforma.ru/api/auth/documents/pdf/zhiznennyj_cikl_razvitiya_i_podderzhki_sistemy"
                  >
                    Жизненный цикл развития и поддержки системы
                  </a>
                </td>
              </tr>
              <tr style={{ height: '55px' }}>
                <td
                  style={{
                    border: '1px solid rgb(160 160 160)',
                    padding: '7px 0 0 10px',
                    verticalAlign: 'baseline'
                  }}
                >
                  Инструкция по развертыванию экземпляра программного
                  обеспечения
                </td>
                <td
                  style={{
                    border: '1px solid rgb(160 160 160)',
                    padding: '7px 0 0 10px',
                    verticalAlign: 'baseline'
                  }}
                >
                  <a
                    style={{ textDecoration: 'none', color: '#3054e8' }}
                    target="_blank"
                    href="https://main.uplatforma.ru/api/auth/documents/pdf/instrukciya_po_razvertyvaniyu_ekzemplyara_programmnogo_obespecheniya"
                  >
                    Инструкция по развертыванию экземпляра программного
                    обеспечения
                  </a>{' '}
                </td>
              </tr>
              <tr style={{ height: '55px' }}>
                <td
                  style={{
                    border: '1px solid rgb(160 160 160)',
                    padding: '7px 0 0 10px',
                    verticalAlign: 'baseline'
                  }}
                >
                  Функциональные характеристики программного обеспечения
                </td>
                <td
                  style={{
                    border: '1px solid rgb(160 160 160)',
                    padding: '7px 0 0 10px',
                    verticalAlign: 'baseline'
                  }}
                >
                  <a
                    style={{ textDecoration: 'none', color: '#3054e8' }}
                    target="_blank"
                    href="https://main.uplatforma.ru/api/auth/documents/pdf/funkcionalnye_harakteristiki_programmnogo_obespecheniya"
                  >
                    Функциональные характеристики программного обеспечения
                  </a>{' '}
                </td>
              </tr>
              <tr style={{ height: '55px' }}>
                <td
                  style={{
                    border: '1px solid rgb(160 160 160)',
                    padding: '7px 0 0 10px',
                    verticalAlign: 'baseline'
                  }}
                >
                  Технические и эксплуатационные характеристики системы
                </td>
                <td
                  style={{
                    border: '1px solid rgb(160 160 160)',
                    padding: '7px 0 0 10px',
                    verticalAlign: 'baseline'
                  }}
                >
                  <a
                    style={{ textDecoration: 'none', color: '#3054e8' }}
                    target="_blank"
                    href="https://main.uplatforma.ru/api/auth/documents/pdf/tehnicheskie_i_ekspluatacionnye_harakteristiki_sistemy"
                  >
                    Технические и эксплуатационные характеристики системы
                  </a>
                </td>
              </tr>
              <tr style={{ height: '55px' }}>
                <td
                  style={{
                    border: '1px solid rgb(160 160 160)',
                    padding: '7px 0 0 10px',
                    verticalAlign: 'baseline'
                  }}
                >
                  Инструкция для пользователя
                </td>
                <td
                  style={{
                    border: '1px solid rgb(160 160 160)',
                    padding: '7px 0 0 10px',
                    verticalAlign: 'baseline'
                  }}
                >
                  <a
                    style={{ textDecoration: 'none', color: '#3054e8' }}
                    target="_blank"
                    href="https://main.uplatforma.ru/api/auth/documents/pdf/instrukciya_dlya_polzovatelya"
                  >
                    Инструкция для пользователя
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            style={{
              paddingTop: '90px',
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <div>
              Свяжитесь с нами:{' '}
              <a
                style={{ textDecoration: 'none', color: '#485858' }}
                href="tel:+74951518075"
              >
                +7 495 151 80 75;
              </a>{' '}
              <a
                style={{ textDecoration: 'none', color: '#485858' }}
                href="mailto:help@uplatforma.ru"
              >
                help@uplatforma.ru
              </a>
            </div>
            <div>ООО Ю-Платформа, 2011 - 2025</div>
          </div>
        </div>
      </div>
    </div>
  );
}
